/**
 * Dlaždica Karaku v knižnici portálu. Obal je banner hry od používateľa
 * (`public/art/karak/cover.webp`, 744×236). Je širší než obal karty, preto
 * je ukotvený vľavo — logo ostane celé, orezáva sa pravý okraj.
 */

import { GameCard } from '../../portal/GameCard.js';
import type { PortalTileProps } from '../registry.js';

export function KarakTile({ navigate }: PortalTileProps) {
  return (
    <GameCard
      title="Karak"
      status="live"
      badge="Plná verzia 1.1"
      titleStyle={{ fontFamily: "'Cinzel', Georgia, serif", fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase' }}
      players="2–5 hráčov"
      duration="30–60 min"
      tags={['Dobrodružstvo', 'Kocky', 'Pre rodiny', 'Aj proti botom', 'Rozšírenie Regent']}
      description="Hrdinovia v katakombách hradu Karak: objavuj chodby, poraz nestvory, odomkni truhlice s pokladom — a keď si trúfaš, zabi draka. Aj s rozšírením Regent: arény, prekliate komnaty a pán Karaku."
      onPlay={() => navigate('#/karak')}
      cover={
        <span className="libCover libCover--karak">
          <img className="libCover__img" src="/art/karak/cover.webp" alt="Karak" draggable={false} />
        </span>
      }
    />
  );
}
